export * from './delete-bewertungs-anlass.component';
export * from './delete-bewertungs-anlass.component.module';